import PropTypes from "prop-types";
import CalendarEventAcceptanceTypes from "@client.enums/calendarEventAcceptanceTypes";

export const meetingType = PropTypes.shape({
  id: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  attendees: PropTypes.arrayOf(PropTypes.string).isRequired,
  recurringId: PropTypes.string,
  attendeesQty: PropTypes.number.isRequired,
  avgPrice: PropTypes.number.isRequired,
  costIndex: PropTypes.number.isRequired,
  startDate: PropTypes.string.isRequired,
  endDate: PropTypes.string.isRequired,
  recurringType: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.oneOf([null]),
  ]),
  pastMeetingsQty: PropTypes.number.isRequired,
  acceptancePercentage: PropTypes.number.isRequired,
  eventResponses: PropTypes.arrayOf(
    PropTypes.shape({
      email: PropTypes.string.isRequired,
      status: PropTypes.oneOf([
        CalendarEventAcceptanceTypes.NeedsAction,
        CalendarEventAcceptanceTypes.Accepted,
        CalendarEventAcceptanceTypes.Declined,
      ]).isRequired,
    })
  ).isRequired,
}).isRequired;
